import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateFreeTierMutation = createMutationHook(
  MembershipsCreatorApiClient.updateFreeTier,
  {
    mutationKey: ['updateFreeTier'],
  },
)
